import React, { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';

import { LayoutSplashScreen } from '../../../_base';
import getMenuConfig from '../../router/MenuConfig';
import * as builder from '../../../_base/ducks/builder';
import { actions as i18nActions } from '../../../_base/ducks/i18n';
import { actions as cartActions } from '../../store/ducks/cart.duck';
import { actions as profileActions } from '../../store/ducks/profile.duck';
import { IAppState } from '../../store/rootDuck';
import { UserRoles } from '../../interfaces/user';
import Preloader from '../../components/other/Preloader/Preloader';

const HomePage: React.FC<TPropsFromRedux> = ({
  userRoles,
  isAuthorized,
  setMenuConfig,
  getOrCreateCart,
  getOrCreateCartLoading,
  getLocalGuestCart,
  isAdmin,
  fetchMe,
}) => {
  const [menuConfig] = useState(getMenuConfig(userRoles, isAuthorized));

  // for user profile in header
  useEffect(() => {
    fetchMe();
  }, []);


  useEffect(() => {
    setMenuConfig(menuConfig);
  }, [setMenuConfig, menuConfig]);

  // Проверка на существование корзины у пользователя
  useEffect(() => {
    if (
      userRoles &&
      !userRoles.includes(UserRoles.ROLE_VENDOR) &&
      !userRoles.includes(UserRoles.ROLE_VENDOR_STAFF) &&
      !isAdmin
    ) {
      getOrCreateCart();
    }
  }, [getOrCreateCart, isAdmin, userRoles]);

  useEffect(() => {
    !isAuthorized && getLocalGuestCart();
  }, [isAuthorized, getLocalGuestCart]);

  if (getOrCreateCartLoading) return <Preloader />;

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Outlet />
    </Suspense>
  );
};

const connector = connect(
  (state: IAppState) => ({
    userRoles: state.auth.user?.roles,
    isAuthorized: state.auth.user != null,
    getOrCreateCartLoading: state.cart.getOrCreateCartLoading,
    isAdmin: state.auth.user?.is_admin,
    me: state.profile.me,
  }),
  {
    fetchMe: profileActions.fetchRequest,
    editMe: profileActions.editRequest,
    setMenuConfig: builder.actions.setMenuConfig,
    getOrCreateCart: cartActions.getOrCreateRequest,
    getLocalGuestCart: cartActions.getLocalGuestCart,
    setLanguage: i18nActions.setLanguage,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HomePage);
